import { BrowserMultiFormatReader, BarcodeFormat, DecodeHintType } from '@zxing/library';
import axios from "axios";

class Invent {

  constructor(el) {
    this.el = el;
    this.codeEl = el.querySelector('[data-invent-code]');
    this.sourceSelect = el.querySelector('[data-invent-video-source-select]');
    this.resultGuess = el.querySelector('[data-invent-result-value]');
    this.unable = el.querySelector('[data-invent-unable]');

    const hints = new Map();
    hints.set(DecodeHintType.POSSIBLE_FORMATS, [
      BarcodeFormat.DATA_MATRIX
    ]);
    this.codeReader = new BrowserMultiFormatReader(hints);
    this.selectedDeviceId = null;
    this.data = {
      inventId: null,
      inventCode: null,
      alreadyScanned: false,
      approved: null,
      productName: null
    }
    this.sentForms = [];
    // pending, loading, guess, incorrect, empty, error
    this.status = 'pending';
    this.setLoading(false);
    this.initVideo();
    this.bind();
  }

  setLoading(loading) {
    this.loading = loading;
    if (loading) {
      this.el.classList.add('_loading');
    } else {
      this.el.classList.remove('_loading');
    }
  }

  getStatus() {
    // pending - ничего никуда не отправлено
    // loading - код есть, отправили на бэк, ждем ответа
    // guess - есть ответ, нужно подтверждение
    // success - получено подтверждение
    // error - ошибка
    // incorrect - не та позиция, нужны фотографии
    // empty - нет кода, нужны фотографии
    if (this.loading) {
      return 'loading';
    }
    if (!this.data.inventId) {
      return 'pending';
    }
    if (this.sentForms.length > 1) {
      return 'success';
    }
    if (!this.data.inventCode) {
      return 'empty';
    }
    if (this.data.inventCode && this.data.approved) {
      return 'success';
    }
    if (this.data.inventCode && (this.data.approved === null)) {
      return 'guess';
    }
    if (this.data.inventCode && (this.data.approved === false)) {
      return 'incorrect';
    }
    return 'error';
  }

  getSelectedDeviceId() {
    return localStorage.getItem('selectedDeviceId');
  }

  setSelectedDeviceId(deviceId) {
    // localstorage
    this.selectedDeviceId = deviceId;
    this.sourceSelect.value = deviceId;
    return localStorage.setItem('selectedDeviceId', this.selectedDeviceId);
  }

  fillSourceSelect(videoDevices) {
    videoDevices.forEach(item => {
      // add option to select
      const option = document.createElement('option');
      option.value = item.deviceId;
      let label = item.label;
      // if contains front
      if (label.includes('front')) {
        label = 'Передняя';
      }
      if (label.includes('back')) {
        label = 'Задняя';
      }
      option.innerText = label;
      this.sourceSelect.appendChild(option);
    });
    if (this.getSelectedDeviceId()) {
      this.sourceSelect.value = this.getSelectedDeviceId();
    }
  }

  getDefaultVideoDeviceId(videoDevices) {
    let backVideoDevice = null;
    videoDevices.forEach(item => {
      if (item.label.includes('back')) {
        backVideoDevice = item.deviceId;
      }
    })
    if (!backVideoDevice) {
      backVideoDevice = videoDevices[0].deviceId;
    }
    return backVideoDevice;
  }

  async initVideo() {
    try {
      const videoDevices = await this.codeReader.listVideoInputDevices();
      if (!videoDevices.length) {
        this.setResult('Невозможно получить доступ к камере');
        return;
      }
      this.selectedDeviceId = this.getSelectedDeviceId();
      if (!this.selectedDeviceId) {
        this.setSelectedDeviceId(this.getDefaultVideoDeviceId(videoDevices));
      }
      this.fillSourceSelect(videoDevices);
      this.codeReader.decodeFromVideoDevice(this.selectedDeviceId, 'video', (result, err) => {
        if (result && result.text) {
          if (this.loading || this.data.inventCode) {
            return;
          }
          this.data.inventCode = window.btoa(result.text);
          this.getOrCreate();
          this.resultGuess.innerText = 'Код получен, загружаем результат...';
        }
      })
    } catch (e) {
      this.setResult(e.toString());
      return;
    }
  }

  async getOrCreate() {
    const dataToServer = {
      fullCode: this.data.inventCode
    };
    this.setLoading(true);
    try {
      const response = await fetch('/inventory-marketplace/get-or-create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(dataToServer)
      });
      const result = await response.json();
      this.setLoading(false);
      if (result && result.id) {
        this.data.inventId = result.id;
        this.data.alreadyScanned = result.approved !== null;
        this.data.productName = result.productName;
        this.nextStep();
      } else {
        this.setResult('Произошла ошибка: ' + JSON.stringify(result));
      }
    } catch (e) {
      this.setResult(e.toString());
    }
  }

  async sendApproved() {
    const dataToServer = {
      approved: this.data.approved
    };
    this.setLoading(true);
    try {
      const response = await fetch(`/inventory-marketplace/approve/${this.data.inventId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(dataToServer)
      });
      this.setLoading(false);
      this.nextStep();
    } catch (e) {
      this.setResult(e.toString());
    }
  }

  nextStep() {
    if (this.data.productName) {
      this.resultGuess.innerText = this.data.productName;
    }
    this.setPageStatus(this.getStatus());
  }

  showBlock(el, show) {
    if (show) {
      el.classList.add('_show');
    } else {
      el.classList.remove('_show');
    }
  }

  setPageStatus(status) {
    this.el.dataset.inventStatus = status;
  }

  setResult(text) {
    this.codeEl.innerText = text;
  }

  addSentForm(name) {
    this.sentForms.push(name);
    this.sentForms = this.sentForms.filter((value, index, array) => {
      return array.indexOf(value) === index;
    });
    this.nextStep();
  }

  async sendFileForm(form) {
    this.setLoading(true);
    const formData = new FormData(form);
    try {
      const response = await axios.post(`/inventory-marketplace/upload/${this.data.inventId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      this.setLoading(false);
      this.addSentForm(form.dataset.inventForm)
      this.nextStep();
      form.classList.add('_success');
    } catch (e) {
      this.setResult(e.toString());
    }
  }

  bind() {
    this.sourceSelect.addEventListener('change', (e) => {
      this.setSelectedDeviceId(e.target.value);
      window.location.reload();
    });
    this.el.querySelectorAll('[data-invent-result-approve]').forEach(item => {
      item.addEventListener('click', (e) => {
        this.data.approved = e.target.dataset.inventResultApprove === '1';
        this.sendApproved();
      })
    })
    this.el.querySelectorAll('form input[type="file"]').forEach(item => {
      item.addEventListener('change', (e) => {
        this.sendFileForm(e.target.closest('form'));
      })
    })
    this.unable.addEventListener('click', (e) => {
      if (confirm('Код действительно не читается или отсутствует?')) {
        this.getOrCreate();
      }
    })
  }
}

if (document.querySelector('[data-invent]')) {
  new Invent(document.querySelector('[data-invent]'));
}